export default function formatExtension(value){
    const str = value.substring(value.length -4, value.length);
       if(str.includes('.')){
           return str.substring(str.length -3, str.length);
       }
       return str;
}